import * as ActionTypes from "../common/actionTypes";
import { Answer } from "./answer";

export const defaultFavoriteState: FavoriteState = {
    isLoading: false
};

// STATE
export interface FavoriteState {
    data?: FavoriteData;
    isLoading: boolean;
    error?: Error;
}

export interface FavoriteData {
    favs: FavoriteEntry[];
}

export interface FavoriteEntry {
    favoriteId: number;
    answerId: number;
    userId: string;
    answer: Answer;
}

// ACTIONS
interface RequestCreateFavorite {
    type: typeof ActionTypes.RequestCreateFavorite;
    favoriteEntry: Omit<FavoriteEntry, 'favoriteId'>;
}

interface ReceiveCreateFavorite {
    type: typeof ActionTypes.ReceiveCreateFavorite;
    data: FavoriteEntry;
}

interface RequestReadCollectionFavorite {
    type: typeof ActionTypes.RequestReadCollectionFavorite
}

interface ReceiveReadCollectionFavorite {
    type: typeof ActionTypes.ReceiveReadCollectionFavorite;
    data: FavoriteData;
}

interface RequestDeleteFavorite {
    type: typeof ActionTypes.RequestDeleteFavorite;
    favoriteEntryId: number;
}

interface ReceiveDeleteFavorite {
    type: typeof ActionTypes.ReceiveDeleteFavorite;
}

interface HandleErrorFavorite {
    type: typeof ActionTypes.HandleErrorFavorite
    error: Error;
}

interface ClearErrorFavorite {
    type: typeof ActionTypes.ClearErrorFavorite;
}

export type KnownAction =
    | RequestCreateFavorite
    | ReceiveCreateFavorite
    | RequestReadCollectionFavorite
    | ReceiveReadCollectionFavorite
    | RequestDeleteFavorite
    | ReceiveDeleteFavorite
    | HandleErrorFavorite
    | ClearErrorFavorite;